import React from "react";
import UserIcon from "../../../../../commons/icons/userIcon";

import { Container, Icon, Label } from './styles';

export default ({ name, picture }) => {
    return (
        <Container>
            <Icon>
                {picture ? <img src={picture} /> : <UserIcon />}
            </Icon>
            <Label>
                {name}
            </Label>
        </Container>
    )
}